import setDisplayName from 'recompose/setDisplayName';
import lifecycle from 'recompose/lifecycle';
import compose from 'recompose/compose';
import { connect } from 'react-redux';

import {
  fetchBarberItems,
  fetchShopItems,
  fetchBarberItemsV2,
  fetchShopItemsV2,
  fetchBrandItemsV2,
} from '../actions';
import { omitProps } from '../../../common/helpers/props';
import { withActionByRole } from '../../../common/helpers/actions';
import { getProductsFromState } from '../selectors';

const getProductsProvider = (isV2 = false) => compose(
  setDisplayName('categoriesProvider'),
  withActionByRole(
    'fetchProducts', ...isV2 ?
      [fetchShopItemsV2, fetchBarberItemsV2, fetchBrandItemsV2] :
      [fetchShopItems, fetchBarberItems, null]
  ),
  connect(
    state => ({
      products: getProductsFromState(state),
    }),
  ),
  lifecycle({
    componentDidMount() {
      this.props.fetchProducts();
    },
  }),
  omitProps(['fetchProducts']),
);

export const productsProviderV2 = getProductsProvider(true);

export default getProductsProvider();
